module.exports = __webpack_public_path__ + "static/numerobiologie-dbb9c9f09efa1d1a494492fa5c38904c.png";